import { render, staticRenderFns } from "./subsystem.vue?vue&type=template&id=06047998&"
import script from "./subsystem.vue?vue&type=script&lang=js&"
export * from "./subsystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports